/**
 * Diff utils for channel
 * @param {BaseChannel} [a]
 * @param {BaseChannel} [b]
 * @returns {boolean}
 * */
export function isDifferentChannel(a, b) {
    if (!a || !b)
        return true;
    return a.url !== b.url;
}
